import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDeliveredDateCell } from "./fulfillment-group-csv-utils";

export const DeliveryDateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Delivery date", cell: (row) => formatDeliveredDateCell(row) };
